import { render } from "./UpExcels.vue?vue&type=template&id=59bc7270"
import script from "./UpExcels.vue?vue&type=script&lang=js"
export * from "./UpExcels.vue?vue&type=script&lang=js"

import "./UpExcels.vue?vue&type=style&index=0&id=59bc7270&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__